module.exports = __webpack_public_path__ + "static/img/menu-about-info.c40e44c7.png";